import { render, staticRenderFns } from "./Filial-editor.vue?vue&type=template&id=0b870f38&"
import script from "./Filial-editor.vue?vue&type=script&lang=js&"
export * from "./Filial-editor.vue?vue&type=script&lang=js&"
import style0 from "./Filial-editor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports